<template>
  <dashboard-main-layout>
    <appbar-bordered v-if="installations && installations.length > 0">
      <template>
        <div class="d-flex align-center">
          <v-btn
            color="white dark--text text-none"
            dark
            elevation="0.5"
            @click="toggleCreate"
          >
            {{ $t("_ajouter_audit_") }}
          </v-btn>

          <v-btn
            color="primary"
            class="ml-3 text-none"
            elevation="0.5"
            @click="importDialog = true"
          >
            <v-icon left>mdi-file-excel</v-icon>
            {{ $t('_importer_excel_') }}
          </v-btn>
        </div>
      </template>
    </appbar-bordered>

    <div class="pa-4">
      <v-card v-if="installationsShowable" elevation="0" class="mb-4">
        <v-card-title>
          <v-text-field
            v-model="search"
            append-icon="mdi-magnify"
            :label="$t('_recherche_')"
            single-line
            hide-details
            clearable
          ></v-text-field>
        </v-card-title>
      </v-card>

      <v-data-table
        :headers="selectedColumnsOrdered"
        :items="installations"
        :search="search"
        :loading="loading"
        item-key="id"
        show-select
        :footer-props="{
          'items-per-page-options': [20, 50, 100, -1],
          'items-per-page-text': $t('_lignes_par_page_'),
        }"
        :items-per-page="20"
        id="level-1-table"
        v-if="installationsShowable"
      >
        <template v-slot:header.data-table-select>
          <div
            class="d-flex justify-center"
            style="cursor: pointer"
            @click="toggleSelectAll"
          >
            <input type="checkbox" :checked="areSelected" />
          </div>
        </template>

        <template v-slot:item="{ item }">
          <tr :class="{ disabled: item.is_forbidden }" style="cursor: pointer">
            <td>
              <div
                class="d-flex justify-center"
                @click.stop="toggleItemSelection(item)"
              >
                <input type="checkbox" :checked="item.checked" />
              </div>
            </td>

            <td
              v-for="column in selectedColumnsOrdered"
              :key="column.key"
              @click="handleRowClick(item, column.key)"
            >
              <template
                v-if="
                  column.key !== 'actions' &&
                  column.key !== 'status' &&
                  !item[column.key]
                "
              >
                -
              </template>

              <div v-else-if="column.key === 'status'">
                <v-chip :color="getStatusChipData(item.id).color" dark small>
                  {{ getStatusChipData(item.id).text }}
                </v-chip>
              </div>

              <div v-else-if="column.key === 'actions'">
                <v-menu
                  v-if="getStatusChipData(item.id).text === 'Live'"
                  offset-y
                  left
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-btn
                      color="primary"
                      small
                      text
                      v-bind="attrs"
                      v-on="on"
                      @click.stop
                    >
                      {{ $t("_actions_") }}
                      <v-icon right small>mdi-chevron-down</v-icon>
                    </v-btn>
                  </template>

                  <v-list dense>
                    <v-list-item link @click="/* action vide */">
                      <v-list-item-title>
                        {{ $t("_supprimer_") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item link @click="/* action vide */">
                      <v-list-item-title>
                        {{ $t("_attacher_a_un_groupe_") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-list-item link @click="/* action vide */">
                      <v-list-item-title>
                        {{ $t("_confier_a_un_utilisateur_") }}
                      </v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item link @click="/* action vide */">
                      <v-list-item-title>
                        {{ $t("_contacter_support_") }}
                      </v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>

                <span v-else>-</span>
              </div>

              <installation-field v-else :column="column.key" :item="item" />
            </td>
          </tr>
        </template>

        <template v-slot:no-results>
          <div class="pa-4 text-center grey--text">
            {{ $t("_aucun_resultat_") || "Aucun résultat trouvé" }}
          </div>
        </template>
      </v-data-table>
    </div>

    <v-dialog v-model="importDialog" max-width="550px" persistent>
      <v-card>
        <v-card-title class="headline grey lighten-2">{{
          $t("_importer_donnees_sites_")
        }}</v-card-title>
        <v-card-text class="pt-4">
          <p class="mb-4">{{ $t('_selectionner_excel_')}}</p>

          <v-file-input
            v-model="selectedFile"
            :label="$t('_fichier_excel_')"
            accept=".xlsx, .xls"
            prepend-icon="mdi-microsoft-excel"
            outlined
            dense
            show-size
            :placeholder="$t('_cliquez_pour_choisir_un_fichier_')"
          ></v-file-input>

          <v-fade-transition>
            <div v-if="selectedFile" class="mt-2">
              <v-alert border="left" colored-border type="info" elevation="1">
                <strong> {{ $t("_pret_pour_l_import_") }}: </strong>
                {{ selectedFile.name }}
              </v-alert>
            </div>
          </v-fade-transition>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="closeImportPopup">{{ $t("_annuler_") }}</v-btn>
          <v-btn
            color="primary"
            :loading="importLoading"            
            @click="submitExcelImport"
            >{{ $t("_valider_") }}</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>

    <PopUpCreation
      v-if="createAudit"
      type="create"
      :data="dataToGive"
      @close="toggleModal"
    />
    <PopUpGetBrouillon
      v-if="openCreate"
      @close="toggleCreate"
      @new="openNewAudit"
      @use="useDraft($event)"
    />
  </dashboard-main-layout>
</template>

<script>
import { mapMutations, mapGetters } from "vuex";
import api from "@/api/api";
import DashboardMainLayout from "@/layouts/Dashboard/MainLayout";
import InstallationField from "@/components/Table/InstallationField";
import AppbarBordered from "@/components/Utils/AppbarBordered";
import PopUpCreation from "@/components/Creation/PopUpCreation.vue";
import PopUpGetBrouillon from "@/components/Creation/PopUpGetBrouillon.vue";

export default {
  components: {
    DashboardMainLayout,
    AppbarBordered,
    InstallationField,
    PopUpCreation,
    PopUpGetBrouillon,
  },
  data() {
    return {
      importDialog: false,
      selectedFile: null,
      importLoading: false,
      loading: false,
      search: "",
      openCreate: false,
      createAudit: false,
      dataToGive: null,
      sitesLive: [],
      currentUserRole: null,
      hardcodedHeaders: [
        { text: "_nom_", value: "installation_name", key: "installation_name" },
        { text: "_commune_", value: "city", key: "city" },
        { text: "_groupe_", value: "state", key: "state" },
        { text: "_statut_", value: "status", key: "status" },
        {
          text: "_date_soumission_",
          value: "audit_start_date",
          key: "audit_start_date",
        },
        { text: '_date_"live"_', value: "date_live", key: "date_live" },
        {
          text: "_puissance_crete_(kwc)_",
          value: "installed_power_kwc",
          key: "installed_power_kwc",
        },
        {
          text: "_date_fin_abonnement_",
          value: "date_fin_abonnement",
          key: "date_fin_abonnement",
        },
        {
          text: "_type_d_installation_",
          value: "installation_type",
          key: "installation_type",
        },
        {
          text: "_actions_",
          value: "actions",
          key: "actions",
          sortable: false,
          filterable: false,
        },
        {
          text: "_seulement_pour_admin_heliocity_",
          value: "seulement_pour_admin_heliocity",
          key: "seulement_pour_admin_heliocity",
        },
      ],
    };
  },
  computed: {
    ...mapGetters(["installations", "utilisateur"]),
    selectedColumnsOrdered() {
      return this.hardcodedHeaders
        .filter((column) => {
          if (column.key !== "seulement_pour_admin_heliocity") return true;
          return this.currentUserRole === "admin";
        })
        .map((c) => ({ ...c, text: this.$t(c.text) }));
    },
    installationsShowable() {
      return (this.installations || []).length > 0;
    },
    areSelected() {
      return (
        this.installations &&
        this.installations.length > 0 &&
        this.installations.every((i) => i.checked)
      );
    },
  },
  methods: {
    ...mapMutations(["SET_INSTALLATIONS", "SET_CUR_INSTALL_ID"]),

    async getInstallationList() {
      this.loading = true;
      try {
        const results = await Promise.allSettled([
          api.get_all_site(),
          this.$store.dispatch("getInstallationList"),
        ]);
        this.sitesLive =
          results[0].status === "fulfilled" ? results[0].value.data || [] : [];
      } catch (e) {
        console.error(e);
      } finally {
        this.loading = false;
      }
    },

    getStatusChipData(id) {
      const site = this.sitesLive.find((s) => s.installation_id == id);
      if (site) {
        if (site.is_new && !site.is_active)
          return { color: "yellow darken-1", text: "Soumis" };
        return { color: "green darken-1", text: "Live" };
      }
      return { color: "blue-grey lighten-2", text: "N/A" };
    },

    toggleSelectAll() {
      const val = !this.areSelected;
      const updated = this.installations.map((i) => ({ ...i, checked: val }));
      this.SET_INSTALLATIONS(updated);
    },

    async loadUserData() {
      try {
        const res = await api.currentUser();
        return res.data.role;
      } catch (e) {
        console.error("Erreur lors de la récupération du rôle :", e);
        return null;
      }
    },

    toggleItemSelection(item) {
      const index = this.installations.findIndex((i) => i.id === item.id);
      if (index !== -1) {
        const updated = [...this.installations];
        updated[index] = {
          ...updated[index],
          checked: !updated[index].checked,
        };
        this.SET_INSTALLATIONS(updated);
      }
    },

    handleRowClick(item, key) {
      if (key === "actions") return;
      this.SET_CUR_INSTALL_ID(item.id);
      this.$router.push(`/installations/show/${item.id}`);
    },

    closeImportPopup() {
      this.importDialog = false;
      this.selectedFile = null;
    },
    async submitExcelImport() {
      this.importDialog = false; 
      this.importLoading = true;
      try {
        if (this.selectedFile) {
          await api.convertsiteexport(this.selectedFile);
        }
      } catch (e) {
        console.error(e);
      } finally {
        this.importLoading = false;
      }
    },
    toggleCreate() {
      this.openCreate = !this.openCreate;
    },
    openNewAudit() {
      this.dataToGive = null;
      this.createAudit = true;
      this.openCreate = false;
    },
    async useDraft(b) {
      this.dataToGive = b;
      this.createAudit = true;
      this.openCreate = false;
    },
    async toggleModal() {
      this.createAudit = false;
      await this.getInstallationList();
    },
  },

  async mounted() {
    this.getInstallationList();
    this.currentUserRole = await this.loadUserData();
  },
};
</script>

<style scoped>
.theme--light.v-data-table > .v-data-table__wrapper > table > thead > tr {
  background-color: rgb(214, 214, 214);
}
.disabled {
  background-color: #f5f5f5;
  opacity: 0.6;
  pointer-events: none;
}
</style>
